import React from 'react';
import { Play, ExternalLink } from 'lucide-react';
interface MusicPlayerProps {
  title: string;
  artist: string;
  albumArt: string;
  streamingUrl?: string;
}
export function MusicPlayer({
  title,
  artist,
  albumArt,
  streamingUrl
}: MusicPlayerProps) {
  return <div className="bg-gradient-to-br from-purple-50 to-sky-50 rounded-2xl p-4 border border-purple-100" data-id="element-135">
      <div className="flex items-center gap-4" data-id="element-136">
        {/* Album Art */}
        <div className="relative flex-shrink-0" data-id="element-137">
          <img src={albumArt} alt={`${title} album art`} className="w-20 h-20 rounded-lg object-cover shadow-md" data-id="element-138" />
          <button className="absolute inset-0 flex items-center justify-center bg-black/40 rounded-lg opacity-0 hover:opacity-100 transition-opacity focus:outline-none focus:ring-2 focus:ring-purple-400" aria-label="Play song" data-id="element-139">
            <Play className="w-8 h-8 text-white fill-white" data-id="element-140" />
          </button>
        </div>

        {/* Song Info */}
        <div className="flex-1 min-w-0" data-id="element-141">
          <h4 className="font-semibold text-slate-800 truncate" data-id="element-142">{title}</h4>
          <p className="text-sm text-slate-600 truncate" data-id="element-143">{artist}</p>
          {streamingUrl && <a href={streamingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs text-purple-600 hover:text-purple-700 mt-1 focus:outline-none focus:ring-2 focus:ring-purple-400 rounded px-1" data-id="element-144">
              <span data-id="element-145">Listen on Spotify</span>
              <ExternalLink className="w-3 h-3" data-id="element-146" />
            </a>}
        </div>
      </div>
    </div>;
}